module.exports = __webpack_public_path__ + "img/W01.f6b42ef4.jpg";